import React from 'react'
import MusicSongFeed from './MusicSongFeed'
import { useMusicPanelView } from './musicPanelView'
import { discoverUrl } from './radioArtistsModel'
import { getJson } from './radioArtistsParts'

// Music's Discover tab: every public song, newest first (New), by recent upvalue
// (Hot), or most upvalued in a window or of all time (Top, Top New); the order
// row lives in the Music header.
export default function MusicDiscover({ panelId }: { panelId?: string }) {
    const { discoverOrder, discoverWindow } = useMusicPanelView(panelId)
    const topWindow = discoverOrder === 'top' ? discoverWindow : null

    return (
        <MusicSongFeed
            queryKey={['musicDiscover', discoverOrder, topWindow]}
            fetchPage={page => getJson(discoverUrl(discoverOrder, topWindow, page))}
            source="music_discover"
            emptyText="No songs yet."
            testId="music-discover"
        />
    )
}
